import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MonthType } from '../../shared/models/month.type.interface';
import { AbstractReportComponent } from '../abstract.report.component';
import { MessageLog, MessageLogMessage, MessageLogResult } from '../models/message.log.interface';
import { ReportService } from '../services/report.service';
import { Dealer } from '../../shared/models/dealer.interface';
import { AdminService } from '../../admin/services/admin.service';

export interface MessageLogParameterData {
  messageLogData: MessageLog;
  validation: string;
  startDate: Date;
  endDate: Date;
  dealers: Dealer[];
  isIDIAdmin: boolean;
}

@Component({
  selector: 'app-message-log',
  templateUrl: './message.log.component.html',
  styleUrl: './message.log.component.scss'
})
export class MessageLogComponent extends AbstractReportComponent {
  report: MessageLogResult[] = [];
  parameters: MessageLog = {
    startDate: '',
    endDate: '',
    dealer_ID: null
  } as MessageLog;

  startDate = new Date();
  endDate = new Date();
  dealers: Dealer[] = [];
  isIDIAdmin: boolean = false;

  /** payrollSummary ctor */
  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService, private datepipe: DatePipe,
    dialog: MatDialog,
    private reportService: ReportService, private adminService: AdminService) {
    super(locale, dialog, deviceDetectorService);

    this.startDate.setMonth(this.endDate.getMonth() - 1);

    this.setupDates();
    if (ReportService._authNavStatusSource.value == "IDI") {

      this.isIDIAdmin = true;
      this.adminService.getDealers()
        .subscribe({
          next: (data) => {
            this.dealers = data;
          },
          complete: () => {
            this.showParameters();
          },
          error: (error: string) => this.onError(error)
        });
    }
    else {
      this.showParameters();
    }

  }

  showDetails(event: Event, message: MessageLogMessage) {
    event.preventDefault();

    this.showDialog(message.messagingEventMessage_Event === 'ERROR' ? message.messagingEventMessage_Response : message.messagingEventMessage_Payload, 'Event Details');
  }

  showParameters() {
    const dialogRef = this.dialog.open(MessageLogParameterDialog, {
      width: '550px',
      data: {
        messageLogData: (<any>Object).assign({}, this.parameters),
        startDate: this.startDate,
        endDate: this.endDate,
        dealers: this.dealers,
        isIDIAdmin: this.isIDIAdmin
      } as MessageLogParameterData
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.parameters = result.messageLogData as MessageLog;
        this.startDate = result.startDate;
        this.endDate = result.endDate;

        this.parameters.startDate = this.datepipe.transform(this.startDate, 'yyyy-MM-ddT00:00:00');
        this.parameters.endDate = this.datepipe.transform(this.endDate, 'yyyy-MM-ddT00:00:00');
        this.parameters.dealer_ID = result.messageLogData.dealer_ID;

        this.reportService.getMessageLogReport(this.parameters)
          .subscribe({
            next: (data: MessageLogResult[]) => {
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }
}

@Component({
  selector: 'message-log.parameter.dialog',
  templateUrl: 'message.log.parameter.dialog.html',
})
export class MessageLogParameterDialog {

  errors: string = '';
  isIDIAdmin: boolean = false;
  dealers: Dealer[] = []
  dealerId: number = null;

  constructor(
    public dialogRef: MatDialogRef<MessageLogParameterDialog>,
    @Inject(MAT_DIALOG_DATA) public data: MessageLogParameterData) {

  }

  runReport(form: NgForm): void {
    this.errors = '';

    if (!form.valid) {
      return;
    }

    if (form.valid) {
      this.dialogRef.close(this.data);
    }
  }

  isValid() { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

